import { type MessageInstance } from "antd/es/message/interface";
import { type AxiosError } from "axios";

type ErrorResponse =
  | { message?: string }
  | { message?: { errors?: string[]; message?: string[] } };

export const errorHandler = (error: unknown, notify: MessageInstance) => {
  const err = error as AxiosError<ErrorResponse>;
  const data = err.response?.data;

  if (!data?.message) {
    notify.error("Server Error");
    return;
  }

  if (typeof data?.message === "string") {
    notify.error(data?.message);
  } else if (typeof data?.message?.message === "string") {
    notify.error(data?.message?.message);
  } else if (
    Array.isArray(data?.message?.errors) &&
    data?.message?.errors?.length
  ) {
    data?.message?.errors.forEach((msg) => notify.error(msg));
  } else if (
    Array.isArray(data?.message?.message) &&
    data?.message?.message?.length
  ) {
    data?.message?.message.forEach((msg) => notify.error(msg));
  } else {
    notify.error("Server Error");
  }
};
